// Module
var code = "<h1 id=fileviewer-文件预览>FileViewer 文件预览</h1> <p>用于预览、下载文件。</p> <p>提供统一的文件链接操作。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>...。</li> </ul> ";
// Exports
module.exports = code;